import { Spin } from 'antd';
import * as React from 'react';

import { Logo } from '../Logo';

import s from './FullPageLoader.module.scss';

const FullPageLoader: React.FC = () => {
  return (
    <div className={s.loader}>
      <Logo className={s.loader__logo} />
      <Spin size="large" />
    </div>
  );
};

export default React.memo(FullPageLoader);
